import moment from 'moment';
import qs from 'qs';
export var XDateType;
(function (XDateType) {
    XDateType["X"] = "X";
    XDateType["ISO"] = "ISO";
})(XDateType || (XDateType = {}));
export const DATE_UNIX = 'X';
export const DATE_UNIX_MS = 'x';
export const DATE_ISO = 'YYYY-MM-DD';
export const DATETIME_ISO = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const TIME_ISO = 'HH:mm';
export const toTimeType = (m) => m?.format(TIME_ISO);
export const fromTimeType = (v) => moment.utc(v, TIME_ISO);
export const toDateType = (m) => m?.format(DATE_ISO);
export const fromDateType = (v) => moment.utc(v, DATE_ISO);
export const fromDateTimeType = (v) => {
    if (v === null)
        return null;
    if (v === undefined)
        return undefined;
    return moment.utc(v, typeof v === 'number'
        ? DATE_UNIX
        : DATETIME_ISO);
};
export const toDateTimeType = (m) => m?.format(DATETIME_ISO);
export const toDateTimeUnixType = (m) => {
    if (m === null)
        return null;
    if (m === undefined)
        return undefined;
    return +m.format(DATE_UNIX);
};
export const toDateTimeUnixTypeMs = (m) => {
    if (m === null)
        return null;
    if (m === undefined)
        return undefined;
    return +m.format(DATE_UNIX_MS);
};
const stringifyConfig = {
    arrayFormat: 'brackets',
};
// As we have only NULL on backend side & typescript has tons of features for `undefined` type, we cast
// backend `null` into frontend `undefined`
const reviver = (k, v) => {
    if (v === null) {
        return undefined;
    }
    return v;
};
// the following function has been taken from axios codebase, modified to pass the reviver
// https://github.com/axios/axios/blob/16b5718954d88fbefe17f0b91101d742b63209c7/lib/defaults.js#L57-L65
const transformResponse = [
    (data) => {
        if (typeof data === 'string') {
            try {
                // eslint-disable-next-line no-param-reassign
                data = JSON.parse(data, reviver);
            }
            catch (e) { /* Ignore */ }
        }
        return data;
    },
];
const encodeQueryParams = (queryParameters, params = stringifyConfig) => {
    const queryParams = queryParameters && Object.keys(queryParameters).length
        ? qs.stringify(queryParameters, params)
        : null;
    return queryParams ? `?${queryParams}` : '';
};
const encodeBody = (body) => {
    if (body && !(body instanceof Array) && !Object.keys(body).length) {
        return undefined;
    }
    if (body && typeof body === 'string') {
        return body;
    }
    return JSON.stringify(body);
};
export { transformResponse, encodeQueryParams, encodeBody, };
/**
 * Converts to frontends internal date format that is understood by apis' toDateTime.
 *
 * @param date - Common JS Date object.
 * @returns - Internal api date type.
 */
const fromJSDate = (date) => moment(date);
/**
 * Converts to frontends internal dateTime format that is understood by apis' toDateTime.
 *
 * @param date - Common JS Date object.
 * @returns - Internal api datetime type.
 */
const fromJSDateTime = (date) => moment(date);
export { fromJSDate, fromJSDateTime, };
//# sourceMappingURL=index.js.map